module.exports = {"451003100":"田州镇","451003101":"那坡镇","451003102":"坡洪镇","451003103":"那满镇","451003104":"百育镇","451003105":"玉凤镇","451003106":"头塘镇","451003107":"五村镇","451003108":"洞靖镇","451003204":"巴别乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/451003.json
// module id = 2269
// module chunks = 0